module.exports = __webpack_public_path__ + "img/appAsset-setup--Check.90646a76.svg";